import styled from 'styled-components';

import { DoneFilledIcon } from '@yoweb/ui/components/Icon/DoneFilledIcon';
import { th } from '@yoweb/ui/styles/utils/theme';
import { pxToRem } from '@yoweb/ui/styles/utils';

const CheckBadge = () => (
  <OuterContainer>
    <InnerContainer>
      <DoneFilledIcon />
    </InnerContainer>
  </OuterContainer>
);

const OuterContainer = styled.div`
  align-items: center;
  background-color: ${th.getColor('base000')};
  border-radius: 50%;
  display: inline-flex;
  height: ${pxToRem(30)};
  padding: ${th.getSpace('small1')};
  width: ${pxToRem(30)};
`;

const InnerContainer = styled.div`
  align-items: center;
  background-color: ${th.getColor('success')};
  border-radius: 50%;
  color: ${th.getColor('base100')};
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
`;

export default CheckBadge;
